import BootstrapModal from "bootstrap/js/dist/modal";
import { Router } from "./router.js";

import { PostJSONWithLoadError } from "./fetchers";

export async function ShowLinkedUpdate(updateid) {
    const modalDiv = document.getElementById("modalLinkedUpdate");
    if (!modalDiv) return;
    // Rewrite the url to base train when modal is closed
    modalDiv.addEventListener("hide.bs.modal", () => { Router.RewriteUrl("/"); });
    const modal = BootstrapModal.getOrCreateInstance(modalDiv);
    modal.show();

    // Let other code know the user has already been shown a modal
    window.ShownAModal = true;

    const updateDiv = modalDiv.querySelector("[data-replacement-target]");
    const update = await PostJSONWithLoadError(updateDiv, "/trains/" + window.CurrentTrain.Id + "/updates/" + updateid + "/get");
    const infoCard = document.createElement("train-info-card");
    const trainPost = document.createElement("train-post");
    trainPost.entity = update;
    trainPost.isInModal = true;
    updateDiv.innerHTML = "";
    updateDiv.append(infoCard, trainPost);
}
